import { useMemo } from 'react';

type Edge<T> = {
  node: T | null;
};

type Connection<T> = {
  edges: (Edge<T> | null)[] | null;
};

const useNodesFromConnection = <T extends any>(connection: Connection<T> | null | undefined) =>
  useMemo(() => {
    const edges = connection?.edges;
    const result: T[] = [];

    if (edges) {
      edges.forEach(edge => {
        if (edge?.node) {
          result.push(edge.node);
        }
      });
    }
    return result;
  }, [connection?.edges]);

export default useNodesFromConnection;
